import { SET_DATA_MISTAKES_MODAL_MESSAGE } from './types';

export const setDataMistakesModalMessage = (payload) => {
  return {
    type: SET_DATA_MISTAKES_MODAL_MESSAGE,
    payload
  };
};
